export default __webpack_public_path__ + "static/media/error.b81c6b8f.svg";